
const CrudCodeValues = require("./CrudCodeValues");
module.exports = class LearningObjectiveAssessment extends EcRemoteLinkedData {
	constructor() {
		super("http://www.asd-europe.org/s-series/s3000l", "LearningObjectiveAssessment");
	}
};
